import useResetPassword from "@/services/auth/hooks/useResetPassword";
import { ResetPasswordPayload } from "@/services/auth/type";
import { Button, PasswordInput, Stack } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";

const schema = Yup.object().shape({
  newPassword: Yup.string()
    .required("پسورد را وارد نمایید")
    .matches(
      /^[a-zA-Z0-9!@#$%^&*()_+=-]*$/,
      "لطفا کیبورد خود را به انگلیسی تغییر دهید."
    ),
  newPasswordConfirm: Yup.string()
    .required("تکرار پسورد را وارد نمایید")
    .matches(
      /^[a-zA-Z0-9!@#$%^&*()_+=-]*$/,
      "لطفا کیبورد خود را به انگلیسی تغییر دهید."
    )
    .oneOf([Yup.ref("newPassword"), ""], "عدم تطابق با پسورد"),
});

const ResetPassword = () => {
  const location = useLocation();
  const { phoneNumber, securityToken } = location.state;
  const navigate = useNavigate();
  const { mutate, isLoading } = useResetPassword();
  const form = useForm<ResetPasswordPayload & { newPasswordConfirm?: string }>({
    initialValues: {
      username: phoneNumber,
      securityToken,
      newPassword: "",
      newPasswordConfirm: "",
    },
    validate: yupResolver(schema),
  });
  return (
    <Stack justify="center" h={300}>
      <form
        onSubmit={form.onSubmit((values) => {
          mutate(
            {
              newPassword: values?.newPassword,
              securityToken: securityToken,
              username: phoneNumber,
            },
            {
              onSuccess(data) {
                if (data) {
                  navigate("/auth/verification", {
                    state: {
                      phoneNumber: phoneNumber,
                    },
                  });
                }
              },
            }
          );
        })}
        className="w-100"
      >
        <Stack>
          <PasswordInput
            size="lg"
            label="کلمه عبور جدید"
            withAsterisk
            styles={{
              label: {
                direction: "rtl",
                textAlign: "right",
                display: "flex",
              },
              root: {
                direction: "ltr",
              },
              error: {
                direction: "rtl",
                fontSize: "0.8rem",
              },
            }}
            {...form.getInputProps("newPassword")}
          />
          <PasswordInput
            size="lg"
            label="تکرار کلمه عبور جدید"
            withAsterisk
            styles={{
              label: {
                direction: "rtl",
                textAlign: "right",
                display: "flex",
              },
              root: {
                direction: "ltr",
              },
              error: {
                direction: "rtl",
                fontSize: "0.8rem",
              },
            }}
            {...form.getInputProps("newPasswordConfirm")}
          />
          <Button
            type="submit"
            size="lg"
            mt="md"
            className="w-100"
            loading={isLoading}
          >
            تایید
          </Button>
        </Stack>
      </form>
    </Stack>
  );
};

export default ResetPassword;
